<!--
 * @Author: Junjie
 * @Date: 2022-06-21 16:25:42
 * @LastEditTime: 2023-01-10 15:59:34
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/working/modules/DevWorkingConditionsDetail.vue
-->
<template>
  <a-spin :spinning="confirmLoading">
    <a-card :style="{marginTop: '20px;'}">
      <a-descriptions :title="model.devId_dictText">
        <a-descriptions-item label="当前状态">
          <span v-if="model.curStatus==1">
            <a-tag color="#52c41a">运行</a-tag>
          </span>
          <span v-else>
            <a-tag color="gray">停止</a-tag>
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="持续运行时长">{{ model.continuousRunningDuration | toHoursAndMinutes }}</a-descriptions-item>
      </a-descriptions>
      <a-form @keyup.enter.native="loadHistoryData" layout="inline">
        <a-form-model-item label="时间">
          <a-range-picker
            :placeholder="['开始时间', '结束时间']"
            @change="loadHistoryData"
            format="YYYY-MM-DD HH:mm:ss"
            v-model="timeRange"
            valueFormat="YYYY-MM-DD HH:mm:ss"
          />
        </a-form-model-item>
      </a-form>
      <a-card>
        <v-chart :option="scatterChartOption" style="width: 100%; height: 198px; background-color: #fff" />
      </a-card>
    </a-card>
  </a-spin>
</template>

<script>
  import { getAction } from '@/api/manage'
  import moment from 'dayjs'
  import { use } from 'echarts/core'
  import {
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DataZoomComponent
  } from 'echarts/components';
  import { CustomChart } from 'echarts/charts';
  import { CanvasRenderer } from 'echarts/renderers';
  import VChart from 'vue-echarts'
  import { duration } from '@/utils/TimeRangeUtils'

  use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DataZoomComponent,
    CustomChart,
    CanvasRenderer
  ]);

  export default {
    name: 'DevRunningInfoForm',
    components: {
      VChart,
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          devId_dictText: '',
          curStatus: 0,
          lastOpenTime: '',
          continuousRunningDuration: 0,
          shutdownCount: 0,
          firstOpenTime: '',
          totalRunningDuration: 0,
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          loadDevWorkingConditions: "/device/devWorkingConditions/list",
          loadHistoryData: '/monitor/data/pointdata',
          getCategoryList: '/custom/category/childListByPCode',
        },
        runColor: 'green',
        sropColor: 'orange',
        seriesData: [],
        scatterChartOption: {},
        timeRange: [moment().add(-30, 'days').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    filters: {
      //将分钟转换为小时和分钟
      toHoursAndMinutes (totalMinutes) {
        if (!totalMinutes) return '0分钟'
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        // return { hours, minutes };
        return `${hours}小时${minutes}分`
      },
      //计算设备的剩余寿命（天 ，向下取整）   设备台账的寿命 - 累计运行时间
      mathResidualLife (runningLife, totalRunningDuration) {
        if (!totalRunningDuration) return `${runningLife}天`
        if (!runningLife) return
        const days = (totalRunningDuration / 60 / 24).toFixed(2);
        const residualLife = Math.floor(runningLife - days);
        if (residualLife > 0) {
          return `${residualLife}天`
        } else {
          return `0天`
        }
      },
    },
    methods: {
      show (devId) {
        this.visible = true;
        this.getColorConf();
        this.$nextTick(() => {
          this.loadDevRuningData(devId);
        })
      },
      getColorConf () {
        const that = this;
        getAction(this.url.getCategoryList, {
          pCode: 'A08A01',
        }).then((res) => {
          if (res.success) {
            res.result.forEach(color => {
              if (color.name === 'run') {
                that.runColor = color.cusProp1;
              } else if (color.name === 'stop') {
                that.stopColor = color.cusProp1;
              }
            });
          } else {
            this.$message.warning('公共编码配置不正确，请联系管理员')
          }
        });
      },
      loadDevRuningData (devId) {
        getAction(this.url.loadDevWorkingConditions, { id: devId }).then(res => {
          if (res.success && res.result.records.length > 0) {
            this.model = Object.assign(this.model, res.result.records[0]);
            this.loadHistoryData();
          } else {
            this.$message.error('设备未统计运行情况，请检查是否配置了运行条件！');
          }
        })
      },
      loadHistoryData () {
        const [startTime, endTime] = this.timeRange;
        if (!startTime || !endTime) {
          return
        }
        const diffSeconds = moment(endTime).diff(moment(startTime), 'second');
        let interval = Math.floor(diffSeconds / 2000);
        interval = Math.max(1, interval);
        const parms = {
          startTime,
          endTime,
          points: this.model.pointCode,
          interval
        }
        getAction(this.url.loadHistoryData, parms).then(res => {
          if (res.success) {
            let data = res.result[0]?.details || [];
            const dataArr = this.createData(data);
            this.seriesData = dataArr;
            this.setChartData(dataArr);

          } else {
            this.$message.warning(res.message);
          }
        });
      },
      createData (data) {
        const dataArr = [];
        const expression = `value${this.model.judgingCondition}${this.model.judgingValue}`;
        for (let index = 0; index < data.length; index++) {
          const item = data[index];
          const value = item.value;
          const boolVal = eval(expression) ? 1 : 0;
          dataArr.push([item.timeStamp, boolVal]);
        }
        return dataArr;
      },
      setChartData (dataArr) {
        const that = this;
        this.scatterChartOption = {
          color: [this.runColor, this.stopColor],
          legend: {
            top: 0,
            right: 0,
            selectedMode: false,
            data: ['运行', '停止']
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              const time = params[0].value[0];
              const value = params[0].value[1];
              const dataIndex = params[0].dataIndex;
              let relVal = time;

              const duration = that.getContinousTime(dataIndex, time, value);
              for (let i = 0, l = params.length; i < l; i++) {
                // 遍历出来的值一般是字符串，需要转换成数字，再进项tiFixed四舍五入
                relVal += '<br/>' +
                  (value === 1 ?
                    `<span class="ant-tag ant-tag-has-color" style="background-color: ${that.runColor};">运行</span>` :
                    `<span class="ant-tag ant-tag-has-color" style="background-color: ${that.stopColor};">停止</span>`);
                if (duration) {
                  relVal += `，持续${duration}`;
                }
              }
              return relVal
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: false
            },
            splitLine: {
              show: false,
              interval: 0,
            }
          },
          grid: {
            show: true,
            backgroundColor: this.stopColor
          },
          xAxis: {
            type: 'time'
          },
          series: {
            type: 'line',
            name: '运行',
            lineStyle: {
              width: 0,
            },
            step: 'end',
            symbol: 'none',
            areaStyle: {
              color: this.runColor
            },
            data: dataArr
          },
          toolbox: {
            show: false,
          }
        }
      },
      getContinousTime (dataIndex, startTime, value) {
        for (let index = dataIndex; index < this.seriesData.length; index++) {
          const item = this.seriesData[index];
          if (item[1] !== value) {
            const endTime = item[0];
            return duration(startTime, endTime);
          }
        }
      },
    }
  }
</script>